import axios from 'axios'
import API from './index'

export default {
  get() {
//    const proxyurl = 'https://cors-anywhere.herokuapp.com/'
    const url = API.BASE_URL + 'Documents'
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },

  getDocument(documentId) {
    const url = API.BASE_URL + 'Documents/' + documentId
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },

  create(file) {
    const url = API.BASE_URL + 'Documents'
    return axios
      .post(url, file, {'Content-Type': 'multipart/form-data'})
      .then(response => {
        return response
      })
  },

  delete(id) {
    const url = API.BASE_URL + 'Documents/' + id
    return axios
      .delete(url, {})
      .then(response => {
        return response
      })
  },
}
